import { render, staticRenderFns } from "./VLeaseExpirationSection.vue?vue&type=template&id=b2675dc8&"
import script from "./VLeaseExpirationSection.vue?vue&type=script&lang=js&"
export * from "./VLeaseExpirationSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports